import https from "../pluggins/http";

export const fetchCartasPorte = async ({ id, rol, fecha } = {}) => {
  try {
    const response = await https.post("cartas-porte?today=true", {
      id,
      rol,
      fecha,
    });
    return Array.isArray(response?.data?.data)
      ? response?.data?.data
      : Object.values(response?.data?.data || {});
  } catch (_error) {
    throw _error;
  }
};

export const fetchCartaPorte = async (id) => {
  try {
    const response = await https.get(`cartas-porte/${id}`);
    return response?.data?.data;
  } catch (_error) {
    throw _error;
  }
};

export const crearCartaPorte = async (data) => {
  try {
    const response = await https.post("cartas-porte/create", data);
    return response?.data;
  } catch (_error) {
    throw _error;
  }
};

export const eliminarCartaPorte = async (id, conductorId) => {
  try {
    const response = await https.delete(`cartas-porte/${id}`, {
      data: { conductor_id: conductorId },
    });
    return response?.data;
  } catch (_error) {
    throw _error;
  }
};

export const firmarCartaPorte = async (id, firmaBase64, firmanteNombre, firmanteDni, destinatarioEmailOverride) => {
  try {
    const response = await https.post(`cartas-porte/${id}/firmar`, {
      firma: firmaBase64,
      firmante_nombre: firmanteNombre || null,
      firmante_dni: firmanteDni || null,
      destinatario_email_override: destinatarioEmailOverride || null,
    });
    return response?.data;
  } catch (_error) {
    throw _error;
  }
};

export const downloadPDFCartaPorte = async (id) => {
  try {
    const response = await https.get(`cartas-porte/${id}/download?t=${Date.now()}`, {
      responseType: "blob",
    });
    return response?.data;
  } catch (_error) {
    throw _error;
  }
};

export const viewPDFCartaPorte = async (id) => {
  try {
    const response = await https.get(`cartas-porte/${id}/view?t=${Date.now()}`, {
      responseType: "blob",
    });
    return response?.data;
  } catch (_error) {
    throw _error;
  }
};

export const fetchMaquinas = async (operadorId) => {
  try {
    const response = await https.get("cartas-porte/maquinas", {
      params: { operador_id: operadorId }
    });
    // El backend retorna { status, data }
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    console.error("Error en fetchMaquinas:", _error?.message);
    throw _error;
  }
};

export const fetchPlantasArido = async (operadorId) => {
  try {
    const response = await https.get("cartas-porte/plantas", {
      params: { operador_id: operadorId }
    });
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    throw _error;
  }
};

export const fetchClientesPorte = async (operadorId) => {
  try {
    const response = await https.get("cartas-porte/clientes", {
      params: { operador_id: operadorId }
    });
    return {
      clientes: Array.isArray(response?.data?.data) ? response.data.data : [],
      operador: response?.data?.operador || null,
    };
  } catch (_error) {
    console.error("Error en fetchClientesPorte:", _error?.message);
    throw _error;
  }
};

export const fetchConductoresCartaPorte = async (operadorId) => {
  try {
    const response = await https.get("cartas-porte/conductores", {
      params: { operador_id: operadorId }
    });
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    console.error("Error en fetchConductoresCartaPorte:", _error?.message);
    throw _error;
  }
};

export const fetchCamionesCartaPorte = async (operadorId) => {
  try {
    const response = await https.get("cartas-porte/camiones", {
      params: { operador_id: operadorId }
    });
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    console.error("Error en fetchCamionesCartaPorte:", _error?.message);
    throw _error;
  }
};

export const duplicarCartaPorte = async (id) => {
  try {
    const response = await https.post(`cartas-porte/${id}/duplicate`);
    console.log("Respuesta del API duplicarCartaPorte:", response);
    return response?.data?.data;
  } catch (_error) {
    console.error("Error en duplicarCartaPorte:", _error?.response?.data || _error?.message);
    throw _error;
  }
};

export const actualizarPesoCartaPorte = async (id, peso) => {
  try {
    const response = await https.post(`cartas-porte/${id}/update-peso`, { peso });
    return response?.data?.data;
  } catch (_error) {
    throw _error;
  }
};
